export default {
    login: {
        title: 'Inicia sesión en tu cuenta',
        subtitle: 'Ingresa tus credenciales para acceder al panel de administración',
        emailLabel: 'Email',
        emailPlaceholder: 'nombre@empresa.com',
        passwordLabel: 'Contraseña',
        passwordPlaceholder: '••••••••',
        forgotPassword: '¿Olvidaste tu contraseña?',
        submitButton: 'Iniciar sesión',
        noAccount: '¿No tienes una cuenta?',
        contactAdmin: 'Contactar administrador',
        credentialsTitle: 'Credenciales Demo',
        errorInvalidCredentials: 'Credenciales no válidas',
        errorLogin: 'Error durante el inicio de sesión',
    },
    resetPassword: {
        title: 'Restablecer contraseña',
        subtitle: 'Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña',
        emailLabel: 'Email',
        emailPlaceholder: 'nombre@empresa.com',
        submitButton: 'Enviar enlace de restablecimiento',
        backToLogin: 'Volver al inicio de sesión',
        successTitle: '¡Email enviado!',
        successMessage: 'Te enviamos un enlace para restablecer tu contraseña a',
        successInstructions: 'Revisa tu bandeja de entrada.',
        backToLoginButton: 'Volver al Inicio de Sesión',
        sendAnotherEmail: 'Enviar otro email',
    },
};

